// extracted by mini-css-extract-plugin
export var darkMode = "_redotech-redo-web-src-theme-component-colors-dark-dark-mode";